import { PropsWithChildren } from 'react'

import { Layout } from 'antd'
import { createStyles } from 'antd-style'

const useStyles = createStyles(({ token }) => ({
  container: {
    height: '100%',
    overflow: 'hidden auto',
    boxShadow: token.boxShadowTertiary
  }
}))

const { Sider } = Layout

export const PageSider = ({ children }: PropsWithChildren) => {
  const { styles } = useStyles()

  return (
    <Sider breakpoint='md' className={styles.container} theme='light'>
      {children}
    </Sider>
  )
}
